module.exports = __webpack_public_path__ + "static/media/sun.3cf66943.png";